import styles from "../products/analytics-table.module.css"

export default function Profitability({ data }) {
  return (
    <div className={styles.tableContainer}>
      <h2>Profitability</h2>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Type</th>
              <th>VIP</th>
              <th>Unique Users</th>
              <th>Total Orders</th>
              <th>Total Revenue</th>
              <th>Adjusted Revenue</th>
              <th>Total Profit</th>
              <th>Profit Margin</th>
              <th>Avg Orders Per User</th>
              <th>Revenue Per User</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr key={index}>
                <td>{item._id.userType}</td>
                <td>{item._id.isVip ? "Yes" : "No"}</td>
                <td>{item.uniqueUsers}</td>
                <td>{item.totalOrders}</td>
                <td>{item.totalRevenue}</td>
                <td>{item.adjustedRevenue}</td>
                <td>{item.totalProfit}</td>
                <td>{item.profitMargin}</td>
                <td>{item.avgOrdersPerUser}</td>
                <td>{item.revenuePerUser}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
